import { Routes } from '@angular/router';
import { AdminGuard } from './modules/auth/guards/admin/admin.guard';
import { AuthGuard } from './modules/auth/guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'crash-report',
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'crash-report',
    loadChildren: () => import('./modules/crash-report/crash-report.module').then(m => m.CrashReportModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: '**',
    redirectTo: 'crash-report',
  },
];
